import React from 'react';

interface SubmitAllButtonProps {
  selectedCategory: string;
  filteredSubmissionsCount: number;
  onCompleteAll: () => void;
  isCompletingAll: boolean;
  allEvaluationsComplete: boolean;
}

// Submit All Button - Bottom Right with better styling
const SubmitAllButton: React.FC<SubmitAllButtonProps> = ({
  selectedCategory,
  filteredSubmissionsCount,
  onCompleteAll,
  isCompletingAll,
  allEvaluationsComplete,
}) => {
  if (!selectedCategory || filteredSubmissionsCount === 0) return null;

  return (
    <div className="flex justify-end mt-8 mb-6">
      <button
        onClick={onCompleteAll}
        disabled={isCompletingAll || !allEvaluationsComplete}
        className={`px-8 py-3 rounded-full font-baijamjuree font-semibold text-sm transition-all duration-200 ${
          allEvaluationsComplete && !isCompletingAll
            ? 'bg-black text-white hover:bg-gray-800 hover:shadow-lg transform hover:scale-105'
            : 'bg-gray-400 text-gray-600 cursor-not-allowed'
        }`}
      >
        {isCompletingAll ? (
          <div className="flex items-center gap-2">
            <div className="animate-spin h-4 w-4 border-2 border-gray-400 border-t-transparent rounded-full"></div>
            Submitting Evaluations...
          </div>
        ) : (
          'Submit Evaluations'
        )}
      </button>
    </div>
  );
};

export default SubmitAllButton;
